export default function setRanking() {
  const openButton = document.querySelector('[data-ranking-open]');
  const dialog = document.querySelector('[data-ranking-dialog]');

  if (!openButton || !dialog || typeof dialog.showModal !== 'function') return;

  const closeButton = dialog.querySelector('[data-ranking-close]');

  openButton.addEventListener('click', () => {
    if (!dialog.open) dialog.showModal();
  });

  closeButton?.addEventListener('click', () => {
    dialog.close();
  });

  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  });
}
